import { Component, OnInit, OnDestroy } from '@angular/core';

import { ApplicationMessage } from './ApplicationMessage';
import { MessageService } from '../services/message.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.css']
})
export class MessagesComponent implements OnInit, OnDestroy {
  private showAllMessages = false;
  message: ApplicationMessage;
  messageSub: Subscription;

  constructor(private messageService: MessageService) { }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.messageSub) {
      this.messageSub.unsubscribe();
    }
  }

  get messages(): ApplicationMessage[] {
    return this.messageService.messages;
  }

  clearMessage(id: number): void {
    this.messageService.clearMessage(id);
    if (this.messageCount === 0) {
      this.showAllMessages = false;
    }
  }

  showMessages() {
    this.showAllMessages = true;
  }

  hideMessages() {
    this.showAllMessages = false;
  }

  get show(): boolean {
    return this.showAllMessages && this.messageCount > 0;
  }

  get messageCount(): number {
    return this.messageService.messages.length;
  }
   

}
